export default __webpack_public_path__ + "static/subset-SuisseIntl-Bold-c228f10406d0e9bf3c2adf6136fa15ca.woff2";